<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Football from "@/services/Football";
import Fixtures from "@/services/Fixtures";
import Teams from "@/services/Teams";
import Monitor from "@/services/Monitor";
import ModalAddSportTeam from "@/components/modals/fixtures/ModalAddSportTeam";
import ModalAddSportDataMatch from "@/components/modals/fixtures/ModalAddSportDataMatch";
import ModalEditSportDataMatch from "@/components/modals/fixtures/ModalEditSportDataMatch";
import ModalAddSportStandings from "@/components/modals/fixtures/ModalAddSportStandings";

const PROVIDER = "Azerion";

export default {
  components: {
    Layout,
    PageHeader,
    ModalAddSportTeam,
    ModalAddSportDataMatch,
    ModalEditSportDataMatch,
    ModalAddSportStandings,
  },
  page: {
    title: "Sport Data Manage",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Sport Data Manage",
      provider: PROVIDER,
      items: [
        { text: "Fixtures", href: "/fixtures/matches_new" },
        { text: "Sport Data Manage", active: true },
      ],
      selectedMatchDetails: null,
      tournamentOptions: [],
      stageOptions: [],
      azerionTeamIds: [],

      teamIsBusy: false,
      teamTableData: [],
      teamTotalRows: 0,
      teamCurrentPage: 1,
      teamPerPage: 10,
      teamPageOptions: [10, 25, 50, 100],
      teamFilter: null,
      teamFilterOn: ["team_name", "team_code", "team_type", "team_country"],
      teamSortBy: "team_name",
      teamSortDesc: false,
      teamFilterData: false,
      teamFields: [
        { key: "team_logo", label: "Logo", sortable: false },
        { key: "team_name", label: "Team Name", sortable: true },
        { key: "team_code", label: "Code", sortable: true },
        { key: "team_type", label: "Type", sortable: true },
        { key: "team_country", label: "Country", sortable: true },
        { key: "provider", label: "Provider", sortable: true },
      ],

      matchIsBusy: false,
      matchTableData: [],
      matchTotalRows: 0,
      matchCurrentPage: 1,
      matchPerPage: 10,
      matchPageOptions: [10, 25, 50, 100],
      matchFilter: null,
      matchFilterOn: [
        "match_id",
        "competition_name",
        "home_team_code",
        "away_team_code",
        "match_status",
      ],
      matchSortBy: "date_time",
      matchSortDesc: true,
      matchFilterData: false,
      matchTabIndex: 0,
      matchFields: [
        { key: "competition_name", label: "Competition", sortable: true },
        { key: "home_team_code", label: "Home", sortable: true },
        { key: "away_team_code", label: "Away", sortable: true },
        { key: "score", label: "Score", sortable: false },
        { key: "venue_name", label: "Venue", sortable: true },
        { key: "date_time", label: "Date", sortable: true },
        { key: "match_status", label: "Status", sortable: true },
        { key: "provider", label: "Provider", sortable: true },
        
        "action",
      ],

      standingIsBusy: false,
      standingTableData: [],
      standingTotalRows: 0,
      standingCurrentPage: 1,
      standingPerPage: 10,
      standingPageOptions: [10, 25, 50, 100],
      standingFilter: null,
      standingFilterOn: [
        "competition_name",
        "stage_name",
        "team_name",
        "team_type",
      ],
      standingSortBy: "rank",
      standingSortDesc: false,
      standingFilterData: false,
      standingTabIndex: 0,
      standingFields: [
        { key: "team_type", label: "Squad", sortable: true },
        { key: "competition_name", label: "Competition", sortable: true },
        { key: "stage_name", label: "Stage", sortable: true },
        { key: "rank", label: "Rank", sortable: true },
        { key: "team_name", label: "Team", sortable: true },
        { key: "matches_played", label: "PL", sortable: true },
        { key: "matches_won", label: "W", sortable: true },
        { key: "matches_drawn", label: "D", sortable: true },
        { key: "matches_lost", label: "L", sortable: true },
        { key: "goals_for", label: "GF", sortable: true },
        { key: "goals_against", label: "GA", sortable: true },
        { key: "goal_difference", label: "+/-", sortable: true },
        { key: "points", label: "Pts", sortable: true },
      ],

      error: null,
    };
  },
  computed: {
    matchTournamentTabs() {
      return this.buildTournamentTabs(this.matchTableData, (row) => {
        const name = row.competition_name || "";
        const season = row.tournament_name || "";
        return `${name} ${season}`.trim() || row.tournament_id || "Tournament";
      });
    },
    standingTournamentTabs() {
      return this.buildTournamentTabs(this.standingTableData, (row) => {
        const name = row.competition_name || "";
        const season = row.tournament_season || "";
        return `${name} ${season}`.trim() || row.tournament_id || "Tournament";
      });
    },
    selectedMatchTournamentId() {
      const tab = this.matchTournamentTabs[this.matchTabIndex];
      return tab ? tab.id : null;
    },
    selectedStandingTournamentId() {
      const tab = this.standingTournamentTabs[this.standingTabIndex];
      return tab ? tab.id : null;
    },
    filteredMatchTableData() {
      if (!this.selectedMatchTournamentId) {
        return this.matchTableData;
      }
      return this.matchTableData.filter(
        (row) => row.tournament_id === this.selectedMatchTournamentId
      );
    },
    filteredStandingTableData() {
      if (!this.selectedStandingTournamentId) {
        return this.standingTableData;
      }
      return this.standingTableData.filter(
        (row) => row.tournament_id === this.selectedStandingTournamentId
      );
    },
  },
  watch: {
    matchTabIndex() {
      this.matchCurrentPage = 1;
      this.matchTotalRows = this.filteredMatchTableData.length;
    },
    standingTabIndex() {
      this.standingCurrentPage = 1;
      this.standingTotalRows = this.filteredStandingTableData.length;
    },
  },
  mounted() {
    this.loadAllData();
  },
  methods: {
    buildTournamentTabs(rows, labelFn) {
      const tabs = [];
      const seen = new Set();
      (rows || []).forEach((row) => {
        const id = row.tournament_id;
        if (!id || seen.has(id)) {
          return;
        }
        seen.add(id);
        tabs.push({
          id,
          label: labelFn(row),
        });
      });
      return tabs;
    },

    syncMatchTabSelection() {
      const tabs = this.matchTournamentTabs;
      if (!tabs.length) {
        this.matchTabIndex = 0;
        this.matchTotalRows = 0;
        return;
      }
      if (this.matchTabIndex >= tabs.length) {
        this.matchTabIndex = 0;
      }
      this.matchCurrentPage = 1;
      this.matchTotalRows = this.filteredMatchTableData.length;
    },

    syncStandingTabSelection() {
      const tabs = this.standingTournamentTabs;
      if (!tabs.length) {
        this.standingTabIndex = 0;
        this.standingTotalRows = 0;
        return;
      }
      if (this.standingTabIndex >= tabs.length) {
        this.standingTabIndex = 0;
      }
      this.standingCurrentPage = 1;
      this.standingTotalRows = this.filteredStandingTableData.length;
    },

    providerQuery() {
      return `provider=${encodeURIComponent(this.provider)}`;
    },

    toggleTeamBusy() {
      this.teamIsBusy = !this.teamIsBusy;
    },
    toggleMatchBusy() {
      this.matchIsBusy = !this.matchIsBusy;
    },
    toggleStandingBusy() {
      this.standingIsBusy = !this.standingIsBusy;
    },

    onTeamFiltered(filteredItems) {
      this.teamTotalRows = filteredItems.length;
      this.teamCurrentPage = 1;
    },
    onMatchFiltered(filteredItems) {
      this.matchTotalRows = filteredItems.length;
      this.matchCurrentPage = 1;
    },
    onStandingFiltered(filteredItems) {
      this.standingTotalRows = filteredItems.length;
      this.standingCurrentPage = 1;
    },

    async loadAllData() {
      await this.getSportTournaments();
      await this.getSportStages();
      await this.getSportTeams();
      await this.getSportMatches();
      await this.getSportStandings();
    },

    async getSportTournaments() {
      try {
        const response = await Football.getSportTournaments(this.providerQuery());
        this.tournamentOptions = response.data.data || [];
      } catch (error) {
        this.tournamentOptions = [];
      }
    },

    async getSportStages() {
      try {
        const response = await Monitor.getSportStages(this.providerQuery());
        const stages = response.data.data || [];
        const tournamentMap = {};
        this.tournamentOptions.forEach((tournament) => {
          tournamentMap[tournament.tournament_id] = tournament;
        });
        this.stageOptions = stages.map((stage) => {
          const tournament = tournamentMap[stage.tournament_id] || {};
          return Object.assign({}, stage, {
            tournament_name: tournament.tournament_name || "",
          });
        });
      } catch (error) {
        this.stageOptions = [];
      }
    },

    async getSportTeams() {
      try {
        this.toggleTeamBusy();
        const response = await Football.getSportTeams(this.providerQuery());
        this.teamTableData = (response.data.teams || []).map((team) => ({
          ...team,
          logoError: false,
        }));
        this.azerionTeamIds = this.teamTableData.map((team) => team.team_id);
        this.teamTotalRows = this.teamTableData.length;
        this.teamCurrentPage = 1;
        this.teamFilterData = true;
      } catch (error) {
        this.error = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : "";
        this.teamTableData = [];
        this.azerionTeamIds = [];
        this.teamTotalRows = 0;
        this.teamCurrentPage = 1;
        this.teamFilterData = true;
      } finally {
        this.toggleTeamBusy();
      }
    },

    filterAzerionMatches(matches) {
      if (!Array.isArray(matches)) return [];
      const teamIds = new Set(this.azerionTeamIds);
      return matches.filter((match) => {
        if (match.provider && match.provider === this.provider) return true;
        return (
          teamIds.has(match.home_team_id) ||
          teamIds.has(match.away_team_id)
        );
      });
    },

    async getSportMatches() {
      try {
        this.toggleMatchBusy();
        const response = await Fixtures.getMatches({ provider: this.provider });
        const matches = response.data.matches || response.data.data?.matches || [];
        this.matchTableData = this.filterAzerionMatches(matches);
        this.matchTabIndex = 0;
        this.matchCurrentPage = 1;
        this.matchFilterData = true;
        this.syncMatchTabSelection();
      } catch (error) {
        this.error = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : "";
        this.matchTableData = [];
        this.matchTabIndex = 0;
        this.matchTotalRows = 0;
        this.matchCurrentPage = 1;
        this.matchFilterData = true;
      } finally {
        this.toggleMatchBusy();
      }
    },

    flattenStandings(payload) {
      const rows = [];
      const data = payload && payload.data ? payload.data : payload;
      if (!data || typeof data !== "object") return rows;

      Object.keys(data)
        .filter((key) => key !== "competitions")
        .forEach((teamType) => {
          const competitions = Array.isArray(data[teamType]) ? data[teamType] : [];
          competitions.forEach((competition) => {
            (competition.stages || []).forEach((stage) => {
              (stage.standings || []).forEach((team) => {
                rows.push({
                  team_type: teamType,
                  competition_id: competition.competition_id || "",
                  competition_name: competition.competition_name || "",
                  tournament_id: competition.tournament_id || "",
                  tournament_season: competition.tournament_season || "",
                  stage_id: stage.stage_id || "",
                  stage_name: stage.stage_name || "",
                  team_id: team.team_id || "",
                  team_name: team.team_name || "",
                  rank: team.rank,
                  points: team.points,
                  matches_played: team.matches_played,
                  matches_won: team.matches_won,
                  matches_drawn: team.matches_drawn,
                  matches_lost: team.matches_lost,
                  goals_for: team.goals_for,
                  goals_against: team.goals_against,
                  goal_difference: team.goal_difference,
                });
              });
            });
          });
        });

      return rows;
    },

    async getSportStandings() {
      try {
        this.toggleStandingBusy();
        const response = await Teams.getSportStandings({ provider: this.provider });
        this.standingTableData = this.flattenStandings(response.data);
        this.standingTabIndex = 0;
        this.standingCurrentPage = 1;
        this.standingFilterData = true;
        this.syncStandingTabSelection();
      } catch (error) {
        this.error = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : "";
        this.standingTableData = [];
        this.standingTabIndex = 0;
        this.standingTotalRows = 0;
        this.standingCurrentPage = 1;
        this.standingFilterData = true;
      } finally {
        this.toggleStandingBusy();
      }
    },

    async refreshStages() {
      if (!this.tournamentOptions.length) {
        await this.getSportTournaments();
      }
      await this.getSportStages();
    },

    openAddTeam() {
      this.$bvModal.show("add_sport_team");
    },
    openAddMatch() {
      this.$bvModal.show("add_sport_data_match");
    },
    openEditMatch(item) {
      this.selectedMatchDetails = item;
      this.$bvModal.show("edit_sport_data_match");
    },
    openAddStandings() {
      this.$bvModal.show("add_sport_standings");
    },

    matchStatusVariant(status) {
      const normalized = (status || "").toString().toLowerCase();
      if (normalized.includes("live") || normalized.includes("progress")) return "danger";
      if (normalized.includes("finish") || normalized.includes("ended") || normalized.includes("closed")) return "secondary";
      if (normalized.includes("schedul") || normalized.includes("not_started") || normalized.includes("upcoming")) return "info";
      if (normalized.includes("postpon")) return "warning";
      if (normalized.includes("cancel") || normalized.includes("abandon")) return "dark";
      return "light";
    },

    rankBadgeClass(rank) {
      const n = Number(rank);
      if (n === 1) return "rank-gold";
      if (n === 2) return "rank-silver";
      if (n === 3) return "rank-bronze";
      return "";
    },
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row g-3">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
              <h4 class="card-title m-0 d-flex align-items-center">
                <i class="mdi mdi-account-group-outline me-2 text-success"></i>
                Teams
                <span class="badge bg-light text-dark ms-2 fw-normal">{{ provider }}</span>
                <span v-if="teamFilterData" class="badge bg-success-subtle text-success ms-2 fw-normal">{{ teamTotalRows }} total</span>
              </h4>
              <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light" @click="openAddTeam">
                <i class="mdi mdi-plus me-2"></i>
                Add Team
              </a>
            </div>

            <div class="row mt-4" v-show="teamFilterData">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="teamPerPage" size="sm" :options="teamPageOptions"></b-form-select>
                    &nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <div class="search-box-wrapper d-inline-flex align-items-center">
                    <i class="mdi mdi-magnify search-icon"></i>
                    <b-form-input v-model="teamFilter" type="search" placeholder="Search teams..." class="form-control form-control-sm search-input"></b-form-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0 mt-2">
              <b-table
                :items="teamTableData"
                :busy="teamIsBusy"
                :fields="teamFields"
                responsive="sm"
                hover
                :per-page="teamPerPage"
                :current-page="teamCurrentPage"
                :sort-by.sync="teamSortBy"
                :sort-desc.sync="teamSortDesc"
                :filter="teamFilter"
                :filter-included-fields="teamFilterOn"
                @filtered="onTeamFiltered"
                show-empty
                empty-text="No Data Found"
              >
                <template #cell(team_logo)="row">
                  <div class="d-flex gap-2 align-items-center">
                    <img
                      v-if="row.item.team_logo"
                      class="img-fluid"
                      :src="row.item.team_logo"
                      width="50"
                      alt="logo"
                      @error="() => (row.item.team_logo = null)"
                    />
                    <img
                      v-else
                      class="img-fluid"
                      :src="row.item.logoError ? require('@/assets/images/image_not_found.png') : row.item.team_logo_default"
                      width="50"
                      alt="default logo"
                      @error="() => (row.item.logoError = true)"
                    />
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center my-4">
                    <b-spinner variant="primary" class="align-middle"></b-spinner>
                    <strong class="ms-2">Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>

            <div class="row" v-show="teamFilterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="teamCurrentPage" :total-rows="teamTotalRows" :per-page="teamPerPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
              <h4 class="card-title m-0 d-flex align-items-center">
                <i class="mdi mdi-soccer me-2 text-success"></i>
                Matches
                <span class="badge bg-light text-dark ms-2 fw-normal">{{ provider }}</span>
                <span v-if="matchFilterData" class="badge bg-success-subtle text-success ms-2 fw-normal">{{ matchTotalRows }} total</span>
              </h4>
              <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light" @click="openAddMatch">
                <i class="mdi mdi-plus me-2"></i>
                Add Match
              </a>
            </div>

            <b-tabs
              v-if="matchTournamentTabs.length"
              v-model="matchTabIndex"
              pills
              nav-class="flex-wrap mb-3"
              content-class="p-0"
            >
              <b-tab
                v-for="tab in matchTournamentTabs"
                :key="'match-tab-' + tab.id"
                :title="tab.label"
              />
            </b-tabs>

            <div class="row mt-4" v-show="matchFilterData">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="matchPerPage" size="sm" :options="matchPageOptions"></b-form-select>
                    &nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <div class="search-box-wrapper d-inline-flex align-items-center">
                    <i class="mdi mdi-magnify search-icon"></i>
                    <b-form-input v-model="matchFilter" type="search" placeholder="Search matches..." class="form-control form-control-sm search-input"></b-form-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0 mt-2">
              <b-table
                :items="filteredMatchTableData"
                :busy="matchIsBusy"
                :fields="matchFields"
                responsive="sm"
                hover
                :per-page="matchPerPage"
                :current-page="matchCurrentPage"
                :sort-by.sync="matchSortBy"
                :sort-desc.sync="matchSortDesc"
                :filter="matchFilter"
                :filter-included-fields="matchFilterOn"
                @filtered="onMatchFiltered"
                show-empty
                empty-text="No Data Found"
              >
                <template v-slot:cell(score)="row">
                  <span class="score-pill">{{ row.item.score_home || 0 }} - {{ row.item.score_away || 0 }}</span>
                </template>

                <template v-slot:cell(match_status)="row">
                  <b-badge :variant="matchStatusVariant(row.item.match_status)" class="text-uppercase text-primary">{{ row.item.match_status }}</b-badge>
                </template>

                <template v-slot:cell(action)="row">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" class="px-2 text-primary" title="Edit" @click="openEditMatch(row.item)">
                        <i class="uil uil-pen font-size-18"></i>
                      </a>
                    </li>
                  </ul>
                </template>

                <template #table-busy>
                  <div class="text-center my-4">
                    <b-spinner variant="primary" class="align-middle"></b-spinner>
                    <strong class="ms-2">Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>

            <div class="row" v-show="matchFilterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="matchCurrentPage" :total-rows="matchTotalRows" :per-page="matchPerPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
              <h4 class="card-title m-0 d-flex align-items-center">
                <i class="mdi mdi-podium-gold me-2 text-success"></i>
                Standings
                <span class="badge bg-light text-dark ms-2 fw-normal">{{ provider }}</span>
                <span v-if="standingFilterData" class="badge bg-success-subtle text-success ms-2 fw-normal">{{ standingTotalRows }} total</span>
              </h4>
              <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light" @click="openAddStandings">
                <i class="mdi mdi-plus me-2"></i>
                Add Standings
              </a>
            </div>

            <b-tabs
              v-if="standingTournamentTabs.length"
              v-model="standingTabIndex"
              pills
              nav-class="flex-wrap mb-3"
              content-class="p-0"
            >
              <b-tab
                v-for="tab in standingTournamentTabs"
                :key="'standing-tab-' + tab.id"
                :title="tab.label"
              />
            </b-tabs>

            <div class="row mt-4" v-show="standingFilterData">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="standingPerPage" size="sm" :options="standingPageOptions"></b-form-select>
                    &nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <div class="search-box-wrapper d-inline-flex align-items-center">
                    <i class="mdi mdi-magnify search-icon"></i>
                    <b-form-input v-model="standingFilter" type="search" placeholder="Search standings..." class="form-control form-control-sm search-input"></b-form-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0 mt-2">
              <b-table
                :items="filteredStandingTableData"
                :busy="standingIsBusy"
                :fields="standingFields"
                responsive="sm"
                hover
                :per-page="standingPerPage"
                :current-page="standingCurrentPage"
                :sort-by.sync="standingSortBy"
                :sort-desc.sync="standingSortDesc"
                :filter="standingFilter"
                :filter-included-fields="standingFilterOn"
                @filtered="onStandingFiltered"
                show-empty
                empty-text="No Data Found"
              >
                <template v-slot:cell(rank)="row">
                  <span class="rank-badge" :class="rankBadgeClass(row.item.rank)">{{ row.item.rank }}</span>
                </template>

                <template #table-busy>
                  <div class="text-center my-4">
                    <b-spinner variant="primary" class="align-middle"></b-spinner>
                    <strong class="ms-2">Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>

            <div class="row" v-show="standingFilterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="standingCurrentPage" :total-rows="standingTotalRows" :per-page="standingPerPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

    <ModalAddSportTeam
      :provider="provider"
      :tournament-options="tournamentOptions"
      @onRefresh="getSportTeams"
    />
    <ModalAddSportDataMatch
      :provider="provider"
      :team-options="teamTableData"
      :stage-options="stageOptions"
      :match-options="matchTableData"
      :standing-options="standingTableData"
      @onRefresh="getSportMatches"
    />
    <ModalEditSportDataMatch
      :match-details="selectedMatchDetails"
      @onRefresh="getSportMatches"
    />
    <ModalAddSportStandings
      :provider="provider"
      :team-options="teamTableData"
      :stage-options="stageOptions"
      :match-options="matchTableData"
      :standing-options="standingTableData"
      @onRefresh="getSportStandings"
    />
  </Layout>
</template>

<style scoped>
.score-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  background: #f0f1f3;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.rank-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 26px;
  border-radius: 50%;
  font-weight: 600;
  background: #eef0f2;
  color: #555;
}
.rank-gold {
  background: #fff2cc;
  color: #a3790a;
}
.rank-silver {
  background: #eceff1;
  color: #616a70;
}
.rank-bronze {
  background: #f5e0d0;
  color: #9c5a26;
}

.search-box-wrapper {
  position: relative;
}
.search-icon {
  position: absolute;
  left: 10px;
  color: #b3b7bd;
  font-size: 16px;
  pointer-events: none;
}
.search-input {
  padding-left: 30px;
  min-width: 220px;
}

</style>